module.exports = __webpack_public_path__ + "img/r-badge-member.19c12971.png";